/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LookupRouteImport } from './routes/lookup'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as IndexRouteImport } from './routes/index'
import { Route as JobJobIdDateRouteImport } from './routes/job.$jobId.$date'
import { Route as JobJobIdDateIndexRouteImport } from './routes/job.$jobId.$date.index'
import { Route as JobJobIdDateWalkthroughRouteImport } from './routes/job.$jobId.$date.walkthrough'
import { Route as JobJobIdDateTasksRouteImport } from './routes/job.$jobId.$date.tasks'
import { Route as JobJobIdDateSmallWorksRouteImport } from './routes/job.$jobId.$date.small-works'
import { Route as JobJobIdDateSignoffRouteImport } from './routes/job.$jobId.$date.signoff'
import { Route as JobJobIdDateProtectivePhotosRouteImport } from './routes/job.$jobId.$date.protective-photos'
import { Route as JobJobIdDatePhotosRouteImport } from './routes/job.$jobId.$date.photos'
import { Route as JobJobIdDateMaterialsRouteImport } from './routes/job.$jobId.$date.materials'
import { Route as JobJobIdDateHealthSafetyFilesRouteImport } from './routes/job.$jobId.$date.health-safety-files'
import { Route as JobJobIdDateHealthSafetyRouteImport } from './routes/job.$jobId.$date.health-safety'
import { Route as JobJobIdDateCheckoutRouteImport } from './routes/job.$jobId.$date.checkout'
import { Route as JobJobIdDateCheckinRouteImport } from './routes/job.$jobId.$date.checkin'
import { Route as JobJobIdDateSignoffIndexRouteImport } from './routes/job.$jobId.$date.signoff.index'
import { Route as JobJobIdDateSignoffSignatureRouteImport } from './routes/job.$jobId.$date.signoff.signature'
import { Route as JobJobIdDateSignoffQuestionsRouteImport } from './routes/job.$jobId.$date.signoff.questions'
import { Route as JobJobIdDateSignoffCompleteRouteImport } from './routes/job.$jobId.$date.signoff.complete'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LookupRoute = LookupRouteImport.update({
  id: '/lookup',
  path: '/lookup',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const JobJobIdDateRoute = JobJobIdDateRouteImport.update({
  id: '/job/$jobId/$date',
  path: '/job/$jobId/$date',
  getParentRoute: () => rootRouteImport,
} as any)
const JobJobIdDateIndexRoute = JobJobIdDateIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => JobJobIdDateRoute,
} as any)
const JobJobIdDateWalkthroughRoute = JobJobIdDateWalkthroughRouteImport.update({
  id: '/walkthrough',
  path: '/walkthrough',
  getParentRoute: () => JobJobIdDateRoute,
} as any)
const JobJobIdDateTasksRoute = JobJobIdDateTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => JobJobIdDateRoute,
} as any)
const JobJobIdDateSmallWorksRoute = JobJobIdDateSmallWorksRouteImport.update({
  id: '/small-works',
  path: '/small-works',
  getParentRoute: () => JobJobIdDateRoute,
} as any)
const JobJobIdDateSignoffRoute = JobJobIdDateSignoffRouteImport.update({
  id: '/signoff',
  path: '/signoff',
  getParentRoute: () => JobJobIdDateRoute,
} as any)
const JobJobIdDateProtectivePhotosRoute =
  JobJobIdDateProtectivePhotosRouteImport.update({
    id: '/protective-photos',
    path: '/protective-photos',
    getParentRoute: () => JobJobIdDateRoute,
  } as any)
const JobJobIdDatePhotosRoute = JobJobIdDatePhotosRouteImport.update({
  id: '/photos',
  path: '/photos',
  getParentRoute: () => JobJobIdDateRoute,
} as any)
const JobJobIdDateMaterialsRoute = JobJobIdDateMaterialsRouteImport.update({
  id: '/materials',
  path: '/materials',
  getParentRoute: () => JobJobIdDateRoute,
} as any)
const JobJobIdDateHealthSafetyFilesRoute =
  JobJobIdDateHealthSafetyFilesRouteImport.update({
    id: '/health-safety-files',
    path: '/health-safety-files',
    getParentRoute: () => JobJobIdDateRoute,
  } as any)
const JobJobIdDateHealthSafetyRoute =
  JobJobIdDateHealthSafetyRouteImport.update({
    id: '/health-safety',
    path: '/health-safety',
    getParentRoute: () => JobJobIdDateRoute,
  } as any)
const JobJobIdDateCheckoutRoute = JobJobIdDateCheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => JobJobIdDateRoute,
} as any)
const JobJobIdDateCheckinRoute = JobJobIdDateCheckinRouteImport.update({
  id: '/checkin',
  path: '/checkin',
  getParentRoute: () => JobJobIdDateRoute,
} as any)
const JobJobIdDateSignoffIndexRoute =
  JobJobIdDateSignoffIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => JobJobIdDateSignoffRoute,
  } as any)
const JobJobIdDateSignoffSignatureRoute =
  JobJobIdDateSignoffSignatureRouteImport.update({
    id: '/signature',
    path: '/signature',
    getParentRoute: () => JobJobIdDateSignoffRoute,
  } as any)
const JobJobIdDateSignoffQuestionsRoute =
  JobJobIdDateSignoffQuestionsRouteImport.update({
    id: '/questions',
    path: '/questions',
    getParentRoute: () => JobJobIdDateSignoffRoute,
  } as any)
const JobJobIdDateSignoffCompleteRoute =
  JobJobIdDateSignoffCompleteRouteImport.update({
    id: '/complete',
    path: '/complete',
    getParentRoute: () => JobJobIdDateSignoffRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/lookup': typeof LookupRoute
  '/reset-password': typeof ResetPasswordRoute
  '/job/$jobId/$date': typeof JobJobIdDateRouteWithChildren
  '/job/$jobId/$date/checkin': typeof JobJobIdDateCheckinRoute
  '/job/$jobId/$date/checkout': typeof JobJobIdDateCheckoutRoute
  '/job/$jobId/$date/health-safety': typeof JobJobIdDateHealthSafetyRoute
  '/job/$jobId/$date/health-safety-files': typeof JobJobIdDateHealthSafetyFilesRoute
  '/job/$jobId/$date/materials': typeof JobJobIdDateMaterialsRoute
  '/job/$jobId/$date/photos': typeof JobJobIdDatePhotosRoute
  '/job/$jobId/$date/protective-photos': typeof JobJobIdDateProtectivePhotosRoute
  '/job/$jobId/$date/signoff': typeof JobJobIdDateSignoffRouteWithChildren
  '/job/$jobId/$date/small-works': typeof JobJobIdDateSmallWorksRoute
  '/job/$jobId/$date/tasks': typeof JobJobIdDateTasksRoute
  '/job/$jobId/$date/walkthrough': typeof JobJobIdDateWalkthroughRoute
  '/job/$jobId/$date/': typeof JobJobIdDateIndexRoute
  '/job/$jobId/$date/signoff/complete': typeof JobJobIdDateSignoffCompleteRoute
  '/job/$jobId/$date/signoff/questions': typeof JobJobIdDateSignoffQuestionsRoute
  '/job/$jobId/$date/signoff/signature': typeof JobJobIdDateSignoffSignatureRoute
  '/job/$jobId/$date/signoff/': typeof JobJobIdDateSignoffIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/lookup': typeof LookupRoute
  '/reset-password': typeof ResetPasswordRoute
  '/job/$jobId/$date/checkin': typeof JobJobIdDateCheckinRoute
  '/job/$jobId/$date/checkout': typeof JobJobIdDateCheckoutRoute
  '/job/$jobId/$date/health-safety': typeof JobJobIdDateHealthSafetyRoute
  '/job/$jobId/$date/health-safety-files': typeof JobJobIdDateHealthSafetyFilesRoute
  '/job/$jobId/$date/materials': typeof JobJobIdDateMaterialsRoute
  '/job/$jobId/$date/photos': typeof JobJobIdDatePhotosRoute
  '/job/$jobId/$date/protective-photos': typeof JobJobIdDateProtectivePhotosRoute
  '/job/$jobId/$date/small-works': typeof JobJobIdDateSmallWorksRoute
  '/job/$jobId/$date/tasks': typeof JobJobIdDateTasksRoute
  '/job/$jobId/$date/walkthrough': typeof JobJobIdDateWalkthroughRoute
  '/job/$jobId/$date': typeof JobJobIdDateIndexRoute
  '/job/$jobId/$date/signoff/complete': typeof JobJobIdDateSignoffCompleteRoute
  '/job/$jobId/$date/signoff/questions': typeof JobJobIdDateSignoffQuestionsRoute
  '/job/$jobId/$date/signoff/signature': typeof JobJobIdDateSignoffSignatureRoute
  '/job/$jobId/$date/signoff': typeof JobJobIdDateSignoffIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/lookup': typeof LookupRoute
  '/reset-password': typeof ResetPasswordRoute
  '/job/$jobId/$date': typeof JobJobIdDateRouteWithChildren
  '/job/$jobId/$date/checkin': typeof JobJobIdDateCheckinRoute
  '/job/$jobId/$date/checkout': typeof JobJobIdDateCheckoutRoute
  '/job/$jobId/$date/health-safety': typeof JobJobIdDateHealthSafetyRoute
  '/job/$jobId/$date/health-safety-files': typeof JobJobIdDateHealthSafetyFilesRoute
  '/job/$jobId/$date/materials': typeof JobJobIdDateMaterialsRoute
  '/job/$jobId/$date/photos': typeof JobJobIdDatePhotosRoute
  '/job/$jobId/$date/protective-photos': typeof JobJobIdDateProtectivePhotosRoute
  '/job/$jobId/$date/signoff': typeof JobJobIdDateSignoffRouteWithChildren
  '/job/$jobId/$date/small-works': typeof JobJobIdDateSmallWorksRoute
  '/job/$jobId/$date/tasks': typeof JobJobIdDateTasksRoute
  '/job/$jobId/$date/walkthrough': typeof JobJobIdDateWalkthroughRoute
  '/job/$jobId/$date/': typeof JobJobIdDateIndexRoute
  '/job/$jobId/$date/signoff/complete': typeof JobJobIdDateSignoffCompleteRoute
  '/job/$jobId/$date/signoff/questions': typeof JobJobIdDateSignoffQuestionsRoute
  '/job/$jobId/$date/signoff/signature': typeof JobJobIdDateSignoffSignatureRoute
  '/job/$jobId/$date/signoff/': typeof JobJobIdDateSignoffIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/lookup'
    | '/reset-password'
    | '/job/$jobId/$date'
    | '/job/$jobId/$date/checkin'
    | '/job/$jobId/$date/checkout'
    | '/job/$jobId/$date/health-safety'
    | '/job/$jobId/$date/health-safety-files'
    | '/job/$jobId/$date/materials'
    | '/job/$jobId/$date/photos'
    | '/job/$jobId/$date/protective-photos'
    | '/job/$jobId/$date/signoff'
    | '/job/$jobId/$date/small-works'
    | '/job/$jobId/$date/tasks'
    | '/job/$jobId/$date/walkthrough'
    | '/job/$jobId/$date/'
    | '/job/$jobId/$date/signoff/complete'
    | '/job/$jobId/$date/signoff/questions'
    | '/job/$jobId/$date/signoff/signature'
    | '/job/$jobId/$date/signoff/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/lookup'
    | '/reset-password'
    | '/job/$jobId/$date/checkin'
    | '/job/$jobId/$date/checkout'
    | '/job/$jobId/$date/health-safety'
    | '/job/$jobId/$date/health-safety-files'
    | '/job/$jobId/$date/materials'
    | '/job/$jobId/$date/photos'
    | '/job/$jobId/$date/protective-photos'
    | '/job/$jobId/$date/small-works'
    | '/job/$jobId/$date/tasks'
    | '/job/$jobId/$date/walkthrough'
    | '/job/$jobId/$date'
    | '/job/$jobId/$date/signoff/complete'
    | '/job/$jobId/$date/signoff/questions'
    | '/job/$jobId/$date/signoff/signature'
    | '/job/$jobId/$date/signoff'
  id:
    | '__root__'
    | '/'
    | '/forgot-password'
    | '/login'
    | '/lookup'
    | '/reset-password'
    | '/job/$jobId/$date'
    | '/job/$jobId/$date/checkin'
    | '/job/$jobId/$date/checkout'
    | '/job/$jobId/$date/health-safety'
    | '/job/$jobId/$date/health-safety-files'
    | '/job/$jobId/$date/materials'
    | '/job/$jobId/$date/photos'
    | '/job/$jobId/$date/protective-photos'
    | '/job/$jobId/$date/signoff'
    | '/job/$jobId/$date/small-works'
    | '/job/$jobId/$date/tasks'
    | '/job/$jobId/$date/walkthrough'
    | '/job/$jobId/$date/'
    | '/job/$jobId/$date/signoff/complete'
    | '/job/$jobId/$date/signoff/questions'
    | '/job/$jobId/$date/signoff/signature'
    | '/job/$jobId/$date/signoff/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  LookupRoute: typeof LookupRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  JobJobIdDateRoute: typeof JobJobIdDateRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lookup': {
      id: '/lookup'
      path: '/lookup'
      fullPath: '/lookup'
      preLoaderRoute: typeof LookupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/job/$jobId/$date': {
      id: '/job/$jobId/$date'
      path: '/job/$jobId/$date'
      fullPath: '/job/$jobId/$date'
      preLoaderRoute: typeof JobJobIdDateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/job/$jobId/$date/': {
      id: '/job/$jobId/$date/'
      path: '/'
      fullPath: '/job/$jobId/$date/'
      preLoaderRoute: typeof JobJobIdDateIndexRouteImport
      parentRoute: typeof JobJobIdDateRoute
    }
    '/job/$jobId/$date/walkthrough': {
      id: '/job/$jobId/$date/walkthrough'
      path: '/walkthrough'
      fullPath: '/job/$jobId/$date/walkthrough'
      preLoaderRoute: typeof JobJobIdDateWalkthroughRouteImport
      parentRoute: typeof JobJobIdDateRoute
    }
    '/job/$jobId/$date/tasks': {
      id: '/job/$jobId/$date/tasks'
      path: '/tasks'
      fullPath: '/job/$jobId/$date/tasks'
      preLoaderRoute: typeof JobJobIdDateTasksRouteImport
      parentRoute: typeof JobJobIdDateRoute
    }
    '/job/$jobId/$date/small-works': {
      id: '/job/$jobId/$date/small-works'
      path: '/small-works'
      fullPath: '/job/$jobId/$date/small-works'
      preLoaderRoute: typeof JobJobIdDateSmallWorksRouteImport
      parentRoute: typeof JobJobIdDateRoute
    }
    '/job/$jobId/$date/signoff': {
      id: '/job/$jobId/$date/signoff'
      path: '/signoff'
      fullPath: '/job/$jobId/$date/signoff'
      preLoaderRoute: typeof JobJobIdDateSignoffRouteImport
      parentRoute: typeof JobJobIdDateRoute
    }
    '/job/$jobId/$date/protective-photos': {
      id: '/job/$jobId/$date/protective-photos'
      path: '/protective-photos'
      fullPath: '/job/$jobId/$date/protective-photos'
      preLoaderRoute: typeof JobJobIdDateProtectivePhotosRouteImport
      parentRoute: typeof JobJobIdDateRoute
    }
    '/job/$jobId/$date/photos': {
      id: '/job/$jobId/$date/photos'
      path: '/photos'
      fullPath: '/job/$jobId/$date/photos'
      preLoaderRoute: typeof JobJobIdDatePhotosRouteImport
      parentRoute: typeof JobJobIdDateRoute
    }
    '/job/$jobId/$date/materials': {
      id: '/job/$jobId/$date/materials'
      path: '/materials'
      fullPath: '/job/$jobId/$date/materials'
      preLoaderRoute: typeof JobJobIdDateMaterialsRouteImport
      parentRoute: typeof JobJobIdDateRoute
    }
    '/job/$jobId/$date/health-safety-files': {
      id: '/job/$jobId/$date/health-safety-files'
      path: '/health-safety-files'
      fullPath: '/job/$jobId/$date/health-safety-files'
      preLoaderRoute: typeof JobJobIdDateHealthSafetyFilesRouteImport
      parentRoute: typeof JobJobIdDateRoute
    }
    '/job/$jobId/$date/health-safety': {
      id: '/job/$jobId/$date/health-safety'
      path: '/health-safety'
      fullPath: '/job/$jobId/$date/health-safety'
      preLoaderRoute: typeof JobJobIdDateHealthSafetyRouteImport
      parentRoute: typeof JobJobIdDateRoute
    }
    '/job/$jobId/$date/checkout': {
      id: '/job/$jobId/$date/checkout'
      path: '/checkout'
      fullPath: '/job/$jobId/$date/checkout'
      preLoaderRoute: typeof JobJobIdDateCheckoutRouteImport
      parentRoute: typeof JobJobIdDateRoute
    }
    '/job/$jobId/$date/checkin': {
      id: '/job/$jobId/$date/checkin'
      path: '/checkin'
      fullPath: '/job/$jobId/$date/checkin'
      preLoaderRoute: typeof JobJobIdDateCheckinRouteImport
      parentRoute: typeof JobJobIdDateRoute
    }
    '/job/$jobId/$date/signoff/': {
      id: '/job/$jobId/$date/signoff/'
      path: '/'
      fullPath: '/job/$jobId/$date/signoff/'
      preLoaderRoute: typeof JobJobIdDateSignoffIndexRouteImport
      parentRoute: typeof JobJobIdDateSignoffRoute
    }
    '/job/$jobId/$date/signoff/signature': {
      id: '/job/$jobId/$date/signoff/signature'
      path: '/signature'
      fullPath: '/job/$jobId/$date/signoff/signature'
      preLoaderRoute: typeof JobJobIdDateSignoffSignatureRouteImport
      parentRoute: typeof JobJobIdDateSignoffRoute
    }
    '/job/$jobId/$date/signoff/questions': {
      id: '/job/$jobId/$date/signoff/questions'
      path: '/questions'
      fullPath: '/job/$jobId/$date/signoff/questions'
      preLoaderRoute: typeof JobJobIdDateSignoffQuestionsRouteImport
      parentRoute: typeof JobJobIdDateSignoffRoute
    }
    '/job/$jobId/$date/signoff/complete': {
      id: '/job/$jobId/$date/signoff/complete'
      path: '/complete'
      fullPath: '/job/$jobId/$date/signoff/complete'
      preLoaderRoute: typeof JobJobIdDateSignoffCompleteRouteImport
      parentRoute: typeof JobJobIdDateSignoffRoute
    }
  }
}

interface JobJobIdDateSignoffRouteChildren {
  JobJobIdDateSignoffCompleteRoute: typeof JobJobIdDateSignoffCompleteRoute
  JobJobIdDateSignoffQuestionsRoute: typeof JobJobIdDateSignoffQuestionsRoute
  JobJobIdDateSignoffSignatureRoute: typeof JobJobIdDateSignoffSignatureRoute
  JobJobIdDateSignoffIndexRoute: typeof JobJobIdDateSignoffIndexRoute
}

const JobJobIdDateSignoffRouteChildren: JobJobIdDateSignoffRouteChildren = {
  JobJobIdDateSignoffCompleteRoute: JobJobIdDateSignoffCompleteRoute,
  JobJobIdDateSignoffQuestionsRoute: JobJobIdDateSignoffQuestionsRoute,
  JobJobIdDateSignoffSignatureRoute: JobJobIdDateSignoffSignatureRoute,
  JobJobIdDateSignoffIndexRoute: JobJobIdDateSignoffIndexRoute,
}

const JobJobIdDateSignoffRouteWithChildren =
  JobJobIdDateSignoffRoute._addFileChildren(JobJobIdDateSignoffRouteChildren)

interface JobJobIdDateRouteChildren {
  JobJobIdDateCheckinRoute: typeof JobJobIdDateCheckinRoute
  JobJobIdDateCheckoutRoute: typeof JobJobIdDateCheckoutRoute
  JobJobIdDateHealthSafetyRoute: typeof JobJobIdDateHealthSafetyRoute
  JobJobIdDateHealthSafetyFilesRoute: typeof JobJobIdDateHealthSafetyFilesRoute
  JobJobIdDateMaterialsRoute: typeof JobJobIdDateMaterialsRoute
  JobJobIdDatePhotosRoute: typeof JobJobIdDatePhotosRoute
  JobJobIdDateProtectivePhotosRoute: typeof JobJobIdDateProtectivePhotosRoute
  JobJobIdDateSignoffRoute: typeof JobJobIdDateSignoffRouteWithChildren
  JobJobIdDateSmallWorksRoute: typeof JobJobIdDateSmallWorksRoute
  JobJobIdDateTasksRoute: typeof JobJobIdDateTasksRoute
  JobJobIdDateWalkthroughRoute: typeof JobJobIdDateWalkthroughRoute
  JobJobIdDateIndexRoute: typeof JobJobIdDateIndexRoute
}

const JobJobIdDateRouteChildren: JobJobIdDateRouteChildren = {
  JobJobIdDateCheckinRoute: JobJobIdDateCheckinRoute,
  JobJobIdDateCheckoutRoute: JobJobIdDateCheckoutRoute,
  JobJobIdDateHealthSafetyRoute: JobJobIdDateHealthSafetyRoute,
  JobJobIdDateHealthSafetyFilesRoute: JobJobIdDateHealthSafetyFilesRoute,
  JobJobIdDateMaterialsRoute: JobJobIdDateMaterialsRoute,
  JobJobIdDatePhotosRoute: JobJobIdDatePhotosRoute,
  JobJobIdDateProtectivePhotosRoute: JobJobIdDateProtectivePhotosRoute,
  JobJobIdDateSignoffRoute: JobJobIdDateSignoffRouteWithChildren,
  JobJobIdDateSmallWorksRoute: JobJobIdDateSmallWorksRoute,
  JobJobIdDateTasksRoute: JobJobIdDateTasksRoute,
  JobJobIdDateWalkthroughRoute: JobJobIdDateWalkthroughRoute,
  JobJobIdDateIndexRoute: JobJobIdDateIndexRoute,
}

const JobJobIdDateRouteWithChildren = JobJobIdDateRoute._addFileChildren(
  JobJobIdDateRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  LookupRoute: LookupRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  JobJobIdDateRoute: JobJobIdDateRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
